import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { AssetField } from 'components/Asset/AssetField';
import { CaseAsset } from 'components/Cases/CaseAsset';
import { CaseOwner } from 'components/Cases/CaseOwner/CaseOwner';
import CopyButton from 'components/CopyButton/CopyButton';
import { useFormContext } from 'react-hook-form';
import { CaseListItem, CaseForm } from 'queries/cases/types';

interface CaseDetailsChipsProps {
  selectedRow?: Partial<CaseListItem> | Partial<CaseForm>;
  isFormDisabled: boolean;
}

const CaseDetailsChips: React.FC<CaseDetailsChipsProps> = ({ selectedRow, isFormDisabled }) => {
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const { event_code, start_date, asset, is_able_to_operate } = getValues() || {};

  return (
    <div className="case-detail-chips">
      {event_code && (
        <div className="cases-tag">
          <CopyButton text={event_code} />
        </div>
      )}
      {start_date && (
        <div className="cases-tag">
          <div className="case-label">{t('case:common.created')}:</div>
          <span className="case-value">
            {dayjs(start_date).format(t('components:date_filter.date.datetime_minute'))}
          </span>
        </div>
      )}
      {selectedRow?.id && <CaseOwner isFormDisabled={isFormDisabled} />}
      {selectedRow?.id ? (
        <AssetField
          asset={asset}
          ableToOperate={{
            value: is_able_to_operate,
            handleChange: (value) => setValue('is_able_to_operate', value),
          }}
        />
      ) : (
        <div className="cases-tag-fullwidth">
          <div className="cases-asset-wrapper">
            <div className="cases-asset-title-wrapper">
              {t('case:inputs.asset')}:
              <div className="cases-asset">
                <CaseAsset />
              </div>
            </div>
            <CaseOwner isFormDisabled={isFormDisabled} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseDetailsChips;
